import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {DobryAgentAuthor} from '../../../../shared/interface/dobry-agent-blog-article';
import {DobryAgentAuthorService} from '../../../../shared/services/dobry-agent-author.service';
import {UserPermissions} from '../../../../shared/interface/user-permissions';
import {AuthService} from '../../../../shared/services/auth.service';

@Component({
  selector: 'app-da-author-details',
  templateUrl: './da-author-details.component.html',
  styleUrls: ['./da-author-details.component.scss']
})
export class DaAuthorDetailsComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  authorId?: string;
  loading = false;
  modify = false;

  userPermissions: ReplaySubject<UserPermissions>;
  authorObject?: DobryAgentAuthor;
  author: ReplaySubject<DobryAgentAuthor> = new ReplaySubject<DobryAgentAuthor>(1);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private snack: MatSnackBar,
    private authorService: DobryAgentAuthorService,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.authorId = params.id;
        this.load();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onModificationClosed(): void {
    this.modify = false;
    this.load();
  }

  load(): void {
    if (!this.authorId) {
      this.router.navigate(['/blog-dobry-agent/autorzy']);
      return;
    }

    this.loading = true;

    this.authorService.get(this.authorId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (author: DobryAgentAuthor) => {
          this.authorObject = author;
          this.author.next(author);
          this.loading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;

          this.snack.open('Nie udało się pobrać danych', error.status.toString(), {
            duration: 2000
          });

          this.router.navigate(['/blog-dobry-agent/autorzy']);
        }
      });
  }
}
